function sanitizeHTML(html) {
    var scriptRegex = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
    var eventRegex = /on\w+="[^"]*"/gi;
    return html.replace(scriptRegex, '').replace(eventRegex, '');
}
export default sanitizeHTML;
